import { render, staticRenderFns } from "./AddTemplateAppDialogMasterSchool.vue?vue&type=template&id=2078d12b&scoped=true"
import script from "./AddTemplateAppDialogMasterSchool.vue?vue&type=script&lang=js"
export * from "./AddTemplateAppDialogMasterSchool.vue?vue&type=script&lang=js"
import style0 from "./AddTemplateAppDialogMasterSchool.vue?vue&type=style&index=0&id=2078d12b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2078d12b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2078d12b')) {
      api.createRecord('2078d12b', component.options)
    } else {
      api.reload('2078d12b', component.options)
    }
    module.hot.accept("./AddTemplateAppDialogMasterSchool.vue?vue&type=template&id=2078d12b&scoped=true", function () {
      api.rerender('2078d12b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/templateApp/dialog/AddTemplateAppDialogMasterSchool.vue"
export default component.exports